/**
 * logs module
 */
export default {
  'views/logs/platform': () => import('@/views/logs/platform/index.vue'),
  'views/logs/tenants': () => import('@/views/logs/tenants/index.vue'),
};
